import React from 'react';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from '../../util';
import './ToolsInt.css';
import { cosmosTrackService } from '../../../../cosmosTracking/cosmosTrackService';
import pictureFrame from '../../../../assets/images/picture-frame.png';
import videoIcon from '../../../../assets/images/video.png';
import ticketDiscount from '../../../../assets/images/ticket-discount.png';
import noti from '../../../../assets/images/notification-bing.png';
import arrowRight from '../../../../assets/images/arrow-right.png';


import {
	create_and_share_poster,
	create_polls,
	Tips_from_experts,
	send_notification
} from '../../../../cosmosTracking/cosmosEvents';

function ToolCardInt(props) {
	const { data } = props;

	function isMobile() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent);
	}

	const handleClick = (tool, index) => {
		let eventType;
		switch (index) {
			case 0:
				eventType = create_and_share_poster;
				break;
			case 1:
				eventType = create_polls;
				break;
			case 2:
				eventType = Tips_from_experts;
				break;
			case 3:
				eventType = send_notification;
				break;
			default:
				return;
		}

		cosmosTrackService(eventType);

		if (isMobile()) {
			if (index === 2 || index === 3) {
				directDeepLink(tool?.deeplink, SOURCE_HOME, SOURCE_WEBVIEW);
			} else {
				directDeepLink(tool?.deeplink, SOURCE_HOME);
			}
		} else {
			window.top.postMessage({ url: tool?.deeplink?.weblink }, '*');
		}
	};

	return (
		<>
			{data?.map((tool, index) => (
				<div
					key={index}
					className="tool-card-box"
					onClick={(e) =>{
						e.stopPropagation();
						handleClick(tool, index)}}>
					{index === 0 && <img src={"https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/share-poster-cons-holi-26.png"} alt="Create" width={28} height={28} />}
					{index === 1 && <img src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/tips-trick-icons-holi-2026.png"} alt="Tip & Tricks" width={28} height={28} />}
					{index === 2 && <img src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/share-coopons-icons-holi-26.png"} alt="Create" width={28} height={28} />}
					{index === 3 && <img src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/notification-bing-holi-26.png"} alt="Notifications" width={28} height={28} />}
					<h4>{tool?.text}</h4>
					<img src={"https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/arrow-right-card-holi-26.png"} alt="arrow" width={16} />
				</div>
			))}
		</>
	);
}

export default ToolCardInt;
